import { Popover as ANTDPopover, PopoverProps } from 'antd'
import { COLORS } from 'constants/colors'
import styled from 'styled-components'

const MyPopover = ({ className, ...props }: PopoverProps) => <ANTDPopover {...props} overlayClassName={className} />

export const Popover = styled(MyPopover)`
  .ant-popover-arrow {
    display: none;
  }

  .ant-popover-inner {
    width: 180px;
    padding: 0;
    border: 1px solid #ebebeb;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
  }
`

export const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`

export const OptionItem = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;

  font-weight: 500;
  font-size: 15px;
  line-height: 1.2;
  color: ${({ selected }) => (selected ? COLORS.primary.medium : COLORS.text.default)};

  transition: all 0.2s;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  }

  &:hover {
    color: ${COLORS.primary.medium};
  }
`

export const Check = styled.span`
  color: ${COLORS.primary.medium};
  font-weight: 700;
`

export const MarkAllItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;

  font-weight: 600;
  font-size: 15px;
  line-height: 1.2;
  color: ${COLORS.primary.medium};

  border-top: 1px solid #ebebeb;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`
